// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"740":"63d48e9a890d5a3938ea","748":"68cd90715dcd2111aa0f"}[chunkId] + ".js";
};